/* import __COLOCATED_TEMPLATE__ from './toggle-list.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './toggle-list.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteEditMenuToggleList extends Component {}
